import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { FreightlancerPostRoleSelectComponent } from './freightlancer-post-role-select.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [FreightlancerPostRoleSelectComponent],
  exports: [FreightlancerPostRoleSelectComponent],
})
export class FreightlancerPostRoleSelectModule {}
